module.exports = __webpack_public_path__ + "img/0Q3B5909-12_H_WoodMatted_MockedUp.1447a04a.jpg";